import React, { useState } from 'react';
import { Input } from "@mui/material";
import "./ticketDialog.scss";
import PropTypes from "prop-types";
import Typography from "../../commonComponents/Typography/index.ts";
import GeneralDialog from "../generalDialog/generalDialog";
import HlxButton from "../../commonComponents/button/button.tsx";
import parse from 'html-react-parser';
import { Warning } from '@mui/icons-material';
import SelectBox from 'component/commonComponents/selectBox';
import { StyledAsterisk } from 'component/commonComponents/Textbox/Textbox.style';
import UptimeGeneralDialog from '../../dialogComponents/generalDialog/generalDialog';


const TicketDialog = (props) => {
  const {
    ticketId,
    title,
    subTitle,
    labelBtn,
    description,
    isOpen,
    handleSubmit,
    handleClose,
    requireComment,
    enableComment,
    showComment,
    locale,
    commentLabel,
    selectionItems,
    selectionLabel,
    selectionRequired,
    characterLimit,
    warningConfig,
    localeWarningDialog,
    textboxToolTip
  } = props;
  const [comment, setComment] = useState('');
  const [selectedItem, setSelectedItem] = useState({});
  const [showCancelComment, setShowCancelComment] = useState(false);
  const [onSubmitComment, setOnSubmitComment] = useState(false);
  const [isOpenWarning, setIsOpenWarning] = useState(false);

  const showWarning = warningConfig?.enabled && JSON.parse(localStorage.getItem(warningConfig?.key) || 'true');

  const renderSelectionItems = () => {
    return selectionItems && selectionItems.length > 0
      ? selectionItems.map((item) => (
        {
          name:item,
          value:item,
        }
      ))
      : [];
  };

  const handleChange = (item) => {
    setSelectedItem(item);
    setShowCancelComment(item?.value === locale?.otherReason ? true : false);
  }

  const content = (
    <>
      <Typography id="lbl-ticketdialog-id">
        {parse(description.replace('ticketId', `<b>${ticketId}</b>`))}
        {!!subTitle && (
          <>
            <br />
            <Warning fontSize='small' style={{ color: '#ed9a30', marginRight: 8, marginBottom: -3 }} />
            {subTitle}
          </>
        )}
      </Typography>
      {selectionItems && (
        <SelectBox
          locale={locale}
          className="input-selection"
          label={selectionLabel}
          value={selectedItem}
          handleChange={(e,val) => handleChange(val)}
          options={renderSelectionItems()}
          fullWidth
          required
          variant='outlined'
          textboxToolTip={textboxToolTip}
          id="drp-ticketdialog-selectitem"
        >
        </SelectBox>
      )}
      {(showComment || showCancelComment) && (
        <>
          {commentLabel && <span className={(requireComment || selectedItem === locale?.otherReason) ? 'input-label required' : 'input-label'}>
            <label id="lbl-ticketdialog-comment">{commentLabel}</label> <StyledAsterisk>*</StyledAsterisk>
          </span> }
          <Input
            className="input-dialog"
            multiline={true}
            disableUnderline={true}
            placeholder={locale?.placeholderInput}
            type="text"
            disabled={!enableComment}
            onChange={(event) => setComment(event.target.value)}
            inputProps={{maxLength: characterLimit}}
            value={comment}
            id="txt-ticketdialog-input"
          />
        </>
      )}
    </>
  );

  const generateBtn = () => {
    const reason = selectedItem?.value || "";
    const selectionInvalid = !reason && selectionRequired;
    const commentInvalid = !comment && (requireComment || reason === locale?.otherReason);
    return (
      <HlxButton label={labelBtn}
        onClick={() => {
          if(!showWarning) {
            selectionItems ? handleSubmit(reason, comment) : handleSubmit(comment);
            setComment('');
          } else if(showWarning && !isOpenWarning) {
            if((enableComment && showComment) || showCancelComment) {
              setIsOpenWarning(true);
              setOnSubmitComment(true);
            } else {
              selectionItems ? handleSubmit(reason, comment) : handleSubmit(comment);
              setComment('');
            }
          }
        }}
        disabled={selectionInvalid || commentInvalid}
        id="btn-ticketdialog-submit"
      />
    )
  };

  const confirmWarningDialog = () => {
    const reason = selectedItem?.value || "";
    return (
      <HlxButton
        label={localeWarningDialog?.ok || warningConfig?.editWarning?.labelButton}
        onClick={() => {
          if(!!onSubmitComment) {
            if(showComment || showCancelComment) {
              selectionItems ? handleSubmit(reason, comment) : handleSubmit(comment);
              setOnSubmitComment(false);
            }
          }
          setComment('');
          setIsOpenWarning(false);
          localStorage.setItem(warningConfig?.key, 'false');
          }
        }
        id="btn-ticketdialog-confirm"
      />
    )
  };

  return (
    <>
      <GeneralDialog
        classname="ticket-dialog"
        deviders={false}
        headerBackgroundDefault={false}
        isOpen={isOpen}
        handleClose={() => {
          setComment('');
          setSelectedItem(null);
          handleClose();
          setShowCancelComment(false);
        }}
        title={title}
        content={content}
        buttonSubmit={generateBtn()}
        cancelLabel={locale?.txtCancel}
      />

      <UptimeGeneralDialog
        title={warningConfig?.editWarning?.title || localeWarningDialog?.warning}
        content={warningConfig?.editWarning?.content || localeWarningDialog?.msgITARFedRamp}
        isOpen={isOpenWarning}
        buttonSubmit={confirmWarningDialog()}
        deviders={false}
        headerBackgroundDefault={false}
        hideButtonCancel={true}
        hideCloseIcon={true}
        commonStyles={{ width: '480px' }}
        handleClose={()=>{}}
        headerDefault={true}
        disableBackdropClick={false}
      />
    </>
  )
}

TicketDialog.propTypes = {
  ticketId: PropTypes.string,
  isOpen: PropTypes.bool,
  labelBtn: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  description: PropTypes.string,
  requireComment: PropTypes.bool,
  enableComment: PropTypes.bool,
  showComment: PropTypes.bool,
  commentLabel: PropTypes.string,
  handleSubmit: PropTypes.func,
  handleClose: PropTypes.func,
  selectionItems: PropTypes.any,
  selectionLabel: PropTypes.string,
  selectionRequired: PropTypes.bool,
  characterLimit: PropTypes.number,
  warningConfig: PropTypes.object,
  localeWarningDialog: PropTypes.object
};

TicketDialog.defaultProps = {
  ticketId: 'ID',
  isOpen: true,
  labelBtn: 'CONFIRM',
  title: 'Reject Request',
  subTitle: '',
  description: 'You need to provide a comment before reopening',
  enableComment: true,
  handleSubmit: () => { },
  handleClose: () => { },
  locale : {
    "placeholderInput": "Add comment here...",
    "txtCancel": "CANCEL",
    "otherReason": "Other"
  },
  selectionLabel: "Reason for Cancellation",
  warningConfig: {
    name: "Warning ITAR/FedRamp",
    key: "warningITARFedRamp",
    enabled: false,
    editWarning: {
      title: "",
      content: "",
      labelButton: ""
    }
  },
  localeWarningDialog: {
    warning: "Warning",
    msgITARFedRamp: "System is ITAR/FedRamp compliant.",
    ok: "OK"
  },
}

export default TicketDialog;